import { SubscriptionPlans } from '../../../../../../shared/utils/subscription-plans';

export const isUserOnStarterPlan = (subscribedPlanType) =>
  subscribedPlanType === SubscriptionPlans.EMAIL_STARTER_MONTHLY ||
  subscribedPlanType === SubscriptionPlans.EMAIL_STARTER_YEARLY;
